import { useContext } from "react";
import { Box, Typography } from "@mui/material";
import { UserContext } from "../../context/UserWrapper";

const Articulo = (props) => {
  const { articulo, index } = props;
  const { actions: ua } = useContext(UserContext);

  return (
    <Box key={articulo.codigo + index} className='ms-4 mb-4' style={{ display: "list-item" }}>
      <strong className='border-bottom border-dark d-inline' style={{ listStyle: "disc", fontWeight: "600" }}>
        Código: {articulo.codigo}
      </strong>
      <Typography className='mt-2'>Descripcion: {articulo.descripcion}</Typography>
      <Typography>Unidades: {articulo.unidades ? `${articulo.unidades}` : "Sin unidades"}</Typography>
      {ua.hasRole("tribunales") && <Typography>Puntos: {articulo.puntos ? `${articulo.puntos}` : "Sin especificar"}</Typography>}
    </Box>
  );
};

export default Articulo;
